import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import InsideHeader from '../../components/InsideHeader';
import PageWrapper from '../../components/PageWrapper';
// import LeadCopyAlt from '../../components/LeadCopyAlt';
import List from './List';

function Agents({ page }) {
  return (
    <div id="Agents">
      <PageWrapper>
        <PageHelmet page={page} />
        <main>
          <InsideHeader
            h1="Meet Our Agents"
            background={get(page, 'page_image.contentUrl')}
            caption={get(page, 'page_image.caption')}
          />
          {/*
          <LeadCopyAlt
            image={get(page, 'lead_image')}
            leadCopy={get(page, 'lead_copy')}
            additionalCopy={get(page, 'additional_copy')}
          />
          */}
          <List />
        </main>
      </PageWrapper>
    </div>
  );
}

Agents.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  builder: true,
  page: 'agents',
})(Agents);



// WEBPACK FOOTER //
// ./src/pages/Agents/index.js